import { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { useTooltips } from "../../context/TooltipsContext";

const EnergoTooltip = ({ position, color, style, tKey, msg }) => {

    const { tooltips, tooltipsTrigger, tooltipsLoading } = useTooltips();
    const [helpText, setHelpText] = useState(tooltips?.find(t => t && t.code != null && tKey != null && t.code.toString() === tKey.toString())?.help_text);

    const textColor = color || "text-energo";
    const target = useRef(null);

    useEffect(() => {
        if (msg) {
            setHelpText(msg);
        } 

    }, [msg])

    const renderTooltip = (props) => (
        <Tooltip id={`tooltip-${tKey}`} {...props}>
            {tooltipsLoading ?
                <Spinner animation="border" /> :
                helpText
            }
        </Tooltip>
    );

    if (!tooltipsTrigger || !helpText) return null

    return(
        <div key={`tooltip-icon-${tKey}`}>
            <OverlayTrigger
                placement={position || "top"}
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
                trigger={["click", "hover", "focus"]}
                rootClose
            >
                <span
                    ref={target}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 18,
                        height: 18,
                        cursor: "pointer",
                        WebkitTapHighlightColor: "transparent",
                    }}
                >
                    <FaInfoCircle
                        style={{
                            width: 18,
                            height: 18,
                            minWidth: 18,
                            minHeight: 18,
                            display: "block",
                            flexShrink: 0,
                            ...style,
                        }}
                        className={textColor}
                    />
                </span>
            </OverlayTrigger>
        </div>
    );
}
export default EnergoTooltip;